import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import SignupPage from '@/features/auth/signup/pages/SignupPage.tsx';
import { authRoute } from '@/App.tsx';

const searchSchema = z.object({
  redirect: z.string().optional(),
});

export const signupRoute = createRoute({
  getParentRoute: () => authRoute,
  path: '/signup',
  component: SignupPage,
  validateSearch: searchSchema,
});
